<h2 i18n>PERSONAL INFORMATION</h2>
<div [formGroup]="personalInfoService.personalForm" *ngIf="booking" class="personal-form">
  <div class="student-area">
    <h3 i18n>
      Participant
    </h3>
    <div class="first-column">
      <label i18n="last name">
        Last name:
      </label>
    </div>
    <div class="second-column">
      {{booking.student.lastName}}
    </div>
    <div class="first-column">
      <label i18n>
        First name:
      </label>
    </div>
    <div class="second-column">
      {{booking.student.firstName}}
    </div>
    <div class="first-column">
      <label i18n>
        Phone:
      </label>
    </div>
    <div class="second-column">
      <input pInputText formControlName="studentMobile" id="student-mobile">
    </div>

  </div>
  <div class="first-parent-area">  
    <h3 i18n>
        Parent 1
    </h3>
    <div class="first-column"> 
      <label i18n>
        Last name*:
      </label>
    </div>
    <div class="second-column">
      <input pInputText formControlName="firstParentLastName" id="first-parent-last-name">
      <div *ngIf="(personalInfoService.personalForm.get('firstParentLastName')!.touched 
      && personalInfoService.personalForm.value.firstParentLastName == '') || (submitFail 
      && personalInfoService.personalForm.value.firstParentLastName == '')" i18n class="warning">
        this field can not be empty.
      </div>
    </div>
    <div class="first-column">
      <label i18n>
        First name*:
      </label>
    </div>
    <div class="second-column">
      <input pInputText formControlName="firstParentFirstName" id="first-parent-first-name">
      <div *ngIf="(personalInfoService.personalForm.get('firstParentFirstName')!.touched 
      && personalInfoService.personalForm.value.firstParentFirstName == '') || (submitFail 
      && personalInfoService.personalForm.value.firstParentFirstName == '')" i18n class="warning">
        this field can not be empty.
      </div>
    </div>
    <div class="first-column">
        <label i18n>
          Phone*:
        </label>
      </div>
      <div class="second-column">
        <input pInputText formControlName="firstParentMobile" id="first-parent-mobile">
        <div *ngIf="(personalInfoService.personalForm.get('firstParentMobile')!.touched 
        && personalInfoService.personalForm.value.firstParentMobile == '') || (submitFail 
        && personalInfoService.personalForm.value.firstParentMobile == '')" i18n class="warning">
          this field can not be empty.
        </div>
      </div>
  </div>
  <div class="second-parent-area">
      <h3 i18n>
          Parent 2
        </h3>
    <div class="first-column">
      <label i18n>
        Last name:
      </label>
    </div>
    <div class="second-column">
      <input pInputText formControlName="secondParentLastName" id="second-parent-last-name">
    </div>

    <div class="first-column">
      <label i18n>
        First name:
      </label>
    </div>
    <div class="second-column">
      <input pInputText formControlName="secondParentFirstName" id="second-parent-first-name">
    </div>
    <div class="first-column">
        <label i18n>
            Phone:
        </label>
      </div>
      <div class="second-column">
        <input pInputText formControlName="secondParentMobile" id="second-parent-mobile">
      </div>
  </div>
</div>